import chapter1 from'./chapter1';

const plot = [
  ...chapter1
];

export default plot;
